export const showButtonOptions = (userProfileName: string, userId: number, connection: any) => {
  if (userProfileName !== 'Usuário Padrão') return true;
  if (userId === connection.created_by) return true;

  return false;
};
